import { Alert, Box, Button, Link } from "@mui/material";
import { useDispatch } from "react-redux";
import { setShowModal } from "../../common-ui/modalSlice";

const REPORTS_URL = "https://reports.simpl.org/";

export const GenerateUserReportsDisabledMessage = () => {
  const dispatch = useDispatch();

  return (
    <Box sx={{ p: 2, width: "100%", maxWidth: 360, minWidth: 0 }}>
      <Alert severity="warning" sx={{ mb: 2 }}>
        Generate User Reports has been disabled. Please go to{" "}
        <Link
          href={REPORTS_URL}
          target="_blank"
          rel="noopener noreferrer"
          color="inherit"
          fontWeight={600}
        >
          {REPORTS_URL}
        </Link>{" "}
        to export individual trainee data.
      </Alert>
      <Button
        variant="contained"
        onClick={() => dispatch(setShowModal(false))}
        fullWidth
      >
        Got it
      </Button>
    </Box>
  );
};
